({Component, createFactory} = require 'react') and (PropTypes = require 'prop-types')
style = require './dropdown.styl'
e = require('react-e/bind') style

Async = createFactory require('react-select/async').default
Select = createFactory require('react-select').default
Entry = PropTypes.shape
  label: PropTypes.string.isRequired
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired


class Dropdown extends Component

  @propTypes:
    async: PropTypes.bool
    clearable: PropTypes.bool
    disabled: PropTypes.bool
    loadOptions: PropTypes.func
    onChange: PropTypes.func
    options: PropTypes.arrayOf(Entry)
    value: PropTypes.oneOfType([
      PropTypes.string
      PropTypes.number
      Entry
    ])

  @defaultProps:
    async: no
    clearable: no
    disabled: no
    onChange: -> null
    options: []
    loadOptions: null
    value: null

  _selectedOption: ->
    return null if @props.value is null or @props.value is undefined
    return @props.value if typeof @props.value is 'object'
    option = (@props.options or []).find (entry) => entry?.value is @props.value
    return option if option?
    return {
      label: String(@props.value)
      value: @props.value
    }

  render: ->
    sharedProps =
      className: 'ct-dropdown'
      classNamePrefix: 'ct-dropdown'
      isClearable: @props.clearable
      isDisabled: @props.disabled
      isSearchable: no
      value: @_selectedOption()
      onChange: (option) =>
        @props.onChange option

    e '.dropdown',
      if @props.async
        Async Object.assign {}, sharedProps,
          defaultOptions: @props.options
          loadOptions: @props.loadOptions
      else
        Select Object.assign {}, sharedProps,
          options: @props.options

Dropdown.displayName = "Dropdown"

module.exports = Dropdown
